import { SearchModuleService } from 'src/shared/search.module.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../app/services/auth.service';
import { system_manager, user_access } from '../assets/conf_urls.json';
import { Observable } from 'rxjs';
import { LoggerService } from 'src/shared/logger/logger.service';
import { Levels } from 'src/shared/logger/levels.enum';
import { InsertUnitsComponent } from './dialog-insert-system/insert.systems.component';
import { AccessAuthService } from 'src/shared/access.auth.service';

@Component({
  selector: 'app-system-profile-manager',
  templateUrl: './system-profile-manager.component.html',
  styleUrls: ['./system-profile-manager.component.css']
})
export class SystemProfileManagerComponent implements OnInit {
  switcher_navigator = true;
  valueChanges: Observable<any>;
  @Output() send_system_profile_object = new EventEmitter<{}>();
  show_progressbar = false;
  items: any = {};
  //for user access
  user_permission;
  user_email = localStorage.getItem('useremail');
  verify_user: any

  selected_parent_folder: any
  selected_folder: any
  sort_tree_by = "folder"
  sort_by_list = [
    { value: 'folder', viewValue: 'Folder' },
    { value: 'software_name', viewValue: 'Software Name' },
    { value: 'software_version', viewValue: 'Software Version' },
    { value: 'product_id', viewValue: 'Product Id' }
  ];

  user_info_obj: any;
  adminAuthorization: boolean = false;

  constructor(private _snackBar: MatSnackBar,
    private http: HttpClient,
    private loggerService: LoggerService,
    private searchModuleService: SearchModuleService,
    public dialog: MatDialog,
    public accessAuthService: AccessAuthService) {
  }

  ngOnInit(): void {
    this.accessAuthService.isAdmin.subscribe(data => this.adminAuthorization = data)

    this.searchModuleService.dataTransmitted.subscribe(data =>
      this.recieve_selected_item({ 'text': 'test', 'value': data[0] })
    )
  }

  get_user_access_service(useremail: any) {
    useremail = useremail.trim();

    localStorage.setItem('useremail', useremail);
    var json_object = { 'user_email': useremail };
    this.http.post(user_access.url, json_object).subscribe(data => {

      if (data.toString().length > 0) {
        //if user active
        if (data[0]['is_active'] == 'y') {
          var useraccess = data[0]['user_permission'];
          localStorage.setItem('ua', useraccess);
          //create a session
          //end

        }
        //if user not active
        if (data[0]['is_active'] == 'n') {
          window.location.href = '/login';
        }
      }

    }
    );
    //  end
  }

  check_auth() {
    // for user access
    this.user_permission = localStorage.getItem('ua');
    if (this.user_permission && this.user_email) {

      this.get_user_access_service(this.user_email);

    } else {
      //  user has to login
      window.location.href = '#/login';
    }
    //end
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']
    });

  }

  reload_treeView() {

    setTimeout(() => {
      let element: HTMLElement = document.getElementsByClassName('nav-link')[0] as HTMLElement;
      element.click();

    }, 700)
  }

  click_button() {

    setTimeout(() => {
      try {
        let element: HTMLElement = document.getElementsByClassName('mat-focus-indicator mat-raised-button mat-button-base mat-primary ng-star-inserted')[0] as HTMLElement;
        element.click();

      } catch (error) {

      }



    }, 300)
  }

  publish_system_profile(value) {
    this.send_system_profile_object.emit(value)

  }

  recieve_selected_system(systemrow) {
    this.items = systemrow

    if (systemrow["item"]["name"]) {

      this.openSnackBar(systemrow["item"]["name"] + " was selected", "Ok")
    }
    this.click_button()

  }

  recieve_selected_item(systemobj) {
    this.selected_folder = undefined;
    this.selected_parent_folder = undefined;
    this.items = {};
    if (systemobj["value"]["type"] == 'endpoint') {

      let json_obj = {
        "event": "select_by_id",
        "id": systemobj["value"]["id"]
      }
      this.http.post(system_manager.services, json_obj).subscribe(data => {
        this.items = { "item": data[0] }
        if (data["id"]) {

          this.openSnackBar(data["system_name"] + " was selected", "Ok")
        }
      }, err => {
        this.loggerService.log("SystemProfileManagerComponent", err, Levels.error)
      })

      this.selected_parent_folder = systemobj["value"]["parent"]
      this.click_button()
    }

    else if (systemobj["value"]["type"] == 'folder') {
      this.selected_folder = systemobj
    }
  }
  //function to refetch data if someone changed the location folder for any other unit
  refetchData(data: any) {
    //make its value empty to fire a change event on it
    this.sort_tree_by = '';
    //this settimeout is to delay the other change a bit for the tree ti rerender the change and then fire a new change event
    setTimeout(() => {
      this.sort_tree_by = data;
    }, 100)

  }
  openDialog(): void {
    const dialogRef = this.dialog.open(InsertUnitsComponent, {
      minWidth: '95vw',
      maxWidth: '95vw',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        //this.deleteSystem(systemToBeDeleted);
      }
    });
  }
}
